import React, { Component } from "react";
import { ThemeProvider } from "styled-components";
import ChatBot from "../../lib";

import { apiUrl } from "../config/apiUrl";
import { setSessionId } from "../utils/sessionmanagement";
import stepsConfig from "../config/steps";
import appAnalytics from "../utils/appAnalytics";
import eventConfig from "../config/eventconfig";

const otherFontTheme = {
  background: "#f5f8fb",
  fontFamily: "sans-serif",
  headerBgColor: "#3f51b5",
  headerFontColor: "#fff",
  headerFontSize: "16px",
  botBubbleColor: "#3f51b5",
  botFontColor: "#fff",
  userBubbleColor: "#fff",
  userFontColor: "#4a4a4a",
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      customDelay: 100,
      botDelay: 100
    };
  }

  componentDidMount() {
    this.setSteps();
  }

  setSteps = async () => {
    let paramsString = window.location.search;
    let searchParams = new URLSearchParams(paramsString);
    let chatFormIdentifier = searchParams.get("id");
    let type = searchParams.get("type");

    let uniqueIdentifier = searchParams.get("c");
    // send lan on event
    appAnalytics.sendEventToMetabase(uniqueIdentifier, eventConfig.LAND_ON, {
      chat_identifier: chatFormIdentifier,
      type: type,
    });

    let url = `${apiUrl}chatform?chat_identifier=${chatFormIdentifier}&type=${type}`;
    let response = await fetch(url);
    let result = await response.json();
    if (
      result &&
      Object.keys(result).length !== 0 &&
      result !== "null" &&
      result !== "undefined"
    ) {
      let stepsFromApi = [];
      try{
        if (Array.isArray(result.chat_steps)) {
          stepsFromApi = result.chat_steps;
        } else {
          stepsFromApi = result.chat_steps.chat_steps;
          this.setState({
            customDelay: result.chat_steps.chat_bot_config.custom_delay,
            botDelay: result.chat_steps.chat_bot_config.bot_delay
          })
        }
      } catch(e) {
        stepsFromApi = result.chat_steps;
      }
      let sessionExpiry = result.session_expiry;
      let identifier = result.referrer;
      let identifier_type = result.referrer_type;
      setSessionId(sessionExpiry);
      let processed_steps = null;

      if (type === "skf_lead_doc_upload") {
        let decodedData = JSON.parse(atob(searchParams.get("data")));
        let identifier = decodedData.mobile_no;
        let enable_fields = decodedData.enable_fields;
        identifier_type = 1;
        processed_steps = stepsConfig.processStepsFileUploadEnableFields(
          stepsFromApi,
          chatFormIdentifier,
          type,
          identifier,
          identifier_type,
          enable_fields
        );
      } else if (type === "skf_fully_automated_product") {
        try {
          identifier = JSON.parse(atob(searchParams.get("c")));
        } catch (e) {
          // send lan on event
          appAnalytics.sendEventToMetabase(
            uniqueIdentifier,
            eventConfig.SFX_IDENTIFIER_ERROR,
            {
              chat_identifier: chatFormIdentifier,
              type: type,
            }
          );
          try {
            let search_params = searchParams.get("c") + "=";
            identifier = JSON.parse(atob(search_params));
          } catch (e) {
            try {
              // try getting candidate id directly
              identifier = searchParams.get("c")
              if (identifier === "" || identifier === null){
                // set default identifier in case of empty
                identifier = "13668150"
              }
            } catch (e) {
              // set default identifier in case of error
              identifier = "13668150"
            }
          }
        }
        let url = `${apiUrl}candidate-information?candidate_id=${identifier}`;
        let response = await fetch(url);
        let result = await response.json();

        if (
          result &&
          Object.keys(result).length !== 0 &&
          result !== "null" &&
          result !== "undefined"
        ) {
          let mobileNo = result.mobile_no;
          let candidateName = result.candidate_name;
          let city = result.city;
          let location = result.location;
          identifier_type = 0;
          processed_steps = stepsConfig.processStepsFullyAutomatedOnboarding(
            stepsFromApi,
            chatFormIdentifier,
            type,
            identifier,
            identifier_type,
            candidateName,
            mobileNo,
            city,
            location
          );
        }
      } else {
        identifier_type = 0;
        try {
            identifier = JSON.parse(atob(searchParams.get('c')))
        } catch (e) {
          try {
            let search_params = searchParams.get('c') + '='
            identifier = JSON.parse(atob(search_params))
          } catch (e) {
            try {
              identifier = searchParams.get('c')
              if (identifier === "" || identifier === null){
                // set default identifier in case of empty
                identifier = '18401642'
              }
            } catch (e){
              // set default identifier in case of error
              identifier = '18401642'
            }
          }
        }
        processed_steps = stepsConfig.processStepsGeneric(
          stepsFromApi,
          chatFormIdentifier,
          type,
          identifier,
          identifier_type
        );
      }
      this.setState({
        steps: processed_steps,
      });
    }
  };

  render() {
    return (
      <ThemeProvider theme={otherFontTheme}>
        <React.StrictMode>
          {this.state.steps.length > 0 ? (
            <ChatBot
              botAvatar='https://webcdn.workindia.in/assets/img/ic_wi.png'
              customDelay={this.state.customDelay}
              botDelay={this.state.botDelay}
              steps={this.state.steps}
              enableMobileAutoFocus={true}
            />
          ) : null}
        </React.StrictMode>
      </ThemeProvider>
    );
  }
}

export default App;
